module.exports = __webpack_public_path__ + "img/australia-blood-diseases-male.28a8fcf8.png";